import {Component} from "@angular/core";
import {MemberSearchModel} from "../member-search.model";
import {MemberEntityModel} from "../member-entity.model";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";
import {MemberSearchData} from "../member-search.data";

@Component({
    selector: "wbo-member-search-page",
    templateUrl: "./member-search-page.component.html",
    providers: [provideSearchModel(MemberSearchModel), provideEntityModel(MemberEntityModel)]
})
export class MemberSearchPageComponent extends AbstractSearchPage {
    canDiscontinue(member: MemberSearchData): boolean {
        return !member.integratedLoyaltyId;
    }
}
